import { CancelPromiseError } from './cancel-promise-error'

export const cancelPromise = () => {
  return Promise.reject(new CancelPromiseError())
}
